module.exports = __webpack_public_path__ + "static/schoolsforasia_activity3@2x-d32a44ee5c7b7c877fde34e082ce4487.png";